<template>
  <EditableReminderList
    :reminders="reminders"
    :email-suggestions="$store.getters['clientSuggestionLoader/getEmails'](client.id)"
    :phone-suggestions="$store.getters['clientSuggestionLoader/getPhones'](client.id)"
    :default-email="baseSelectAppropriateClientDetail('EMAIL', client)"
    :default-phone="baseSelectAppropriateClientDetail('SMS', client)"
    :disable="!canAlterReminders"
    :limit="CLIENT_REMINDER_LIMIT"
    @add="addNewReminderRow"
    @remove="removeReminder"
    @email-focus="$store.dispatch('clientSuggestionLoader/loadEmails', client.id)"
    @phone-focus="$store.dispatch('clientSuggestionLoader/loadPhones', client.id)"
  >
    <template #model>
      <q-field
        class="without-padding q-mx-md q-mb-md client-reminder-header"
        hide-bottom-space
        outlined
        dense
        :class="{'sticky-position from-toolbar': reminders.length > 0}"
      >
        <div class="full-width">
          <client-item
            :client="client"
            dense
            without-email
            without-address
            clickable
            prevent-side-click
            @click="viewingClientId = client.id"
          >
            <template #content>
              <q-item-label v-if="reminders.length > 0" class="text-bold text-orange-9">
                {{ reminders.length }} {{ pluraliseString('Reminder', reminders.length) }}
              </q-item-label>
            </template>

            <cancel-button
              label="Remove Client"
              selector=".reminder-group"
              hover-selector-class="bg-red-1"
              @click="$emit('removeClient')"
            />
          </client-item>
        </div>
      </q-field>
    </template>
  </EditableReminderList>

  <ViewClientModal
    :id="viewingClientId"
    :with-quick-links="false"
    :disable-editing="true"
    @close="viewingClientId = null"
  />
</template>

<script>
import fillClientDetailsMixin from '../../../mixins/fillClientDetailsMixin'
import communicationMixin from 'components/partials/communications/communicationMixin'
import { addClientReminder, CLIENT_REMINDER_LIMIT } from 'components/app/calendar/partials/mixins/remindersMixin'

import EditableReminderList from 'components/partials/communications/reminders/EditableReminderList'
import { defineAsyncComponent } from 'vue'

export default {
  components: {
    ViewClientModal: defineAsyncComponent(() => import('components/app/clients/partials/view/Dialog.vue')),
    EditableReminderList
  },
  mixins: [fillClientDetailsMixin, communicationMixin],
  props: {
    event: {
      type: Object,
      required: true
    },
    client: {
      type: Object,
      required: true
    },
    reminders: {
      type: Array,
      required: true
    },
    canAlterReminders: {
      type: Boolean,
      default: false
    }
  },
  emits: ['removeClient'],
  data () {
    return {
      CLIENT_REMINDER_LIMIT,
      viewingClientId: null
    }
  },
  methods: {
    addNewReminderRow () {
      addClientReminder(this.event, this.client, null, true)
    },
    removeReminder ({ value }) {
      this.event.client_reminders.splice(this.event.client_reminders.indexOf(value), 1)
    }
  }
}
</script>

<style lang="scss" scoped>
/* Clip the clickable client item's hover highlight to the field's rounded corners */
.client-reminder-header :deep(.q-field__control) {
  overflow: hidden;
}
</style>
